import type { ReactElement } from 'react';

import { useSession } from '../lib/api/session-context';

import { AppRoutes } from './AppRoutes';

/**
 * The routes, told whether this is the trader's first launch (specs/S3-intro/spec.md R5).
 *
 * Rendered under `SessionGate`, so the session is `ready`. `isNew` is the one of the opening
 * exchange (a renewal never changes it, S2 P4), so reading it at mount is enough. Proposal, to be
 * validated (P4): a small component, so `AppRoutes` stays free of the session and its tab tests
 * need no provider.
 */
export function AppEntry(): ReactElement {
  const session = useSession();
  return <AppRoutes firstLaunch={session.status === 'ready' && session.isNew} />;
}
